import type { DeviceBridge } from '@enp-suite/bridge';
import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { routeTree } from './generated/routeTree.gen.js';
import { RouteError, RoutePending } from './station/route-states.js';

export interface RouterContext {
  queryClient: QueryClient;
  bridge: DeviceBridge;
}

export function createAppRouter(bridge: DeviceBridge) {
  const queryClient = new QueryClient({
    defaultOptions: {
      // Stations run offline for hours: never throw away data because a refetch failed.
      queries: { staleTime: 30_000, refetchOnWindowFocus: false, networkMode: 'always' },
    },
  });
  const router = createRouter({
    routeTree,
    context: { queryClient, bridge },
    defaultPreload: 'intent',
    defaultPendingComponent: RoutePending,
    defaultErrorComponent: RouteError,
    scrollRestoration: true,
  });
  return { router, queryClient };
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>['router'];
  }
}
